import React from "react";
import Layout from "../../../components/layout/layout.js";
import { ImportPage } from "../../../components/stats/import-page.js";

export default function StatsImportPage({ component, ...rest }) {
  return <Layout Component={ImportPage} {...rest} controlsDisabled />;
}
